import './HeroSection.css';
import heroImage from './assets/oversight-bro.png'; // Replace with your actual image file

function HeroSection() {
  return (
    <section className="hero">
      <div className="hero-content">
        <h1 className="hero-title">Welcome to FiscAI</h1>
        <p className="hero-subtitle">
          AI-powered financial insights built for Australia's modern businesses.
focussed on the Perth market.
        </p>
        <button className="hero-button">Get Started</button>
      </div>
      <div className="hero-image">
        <img src={heroImage} alt="FiscAI dashboard illustration" />
      </div>
    </section>
  );
}

export default HeroSection;
